import React from 'react';
import {Link} from 'react-router-dom';
import {FormattedDate, FormattedMessage, FormattedTime} from 'react-intl';
import {constants} from '@neosvoc/nv-platform-core-common';
import UserStatusBadge from './UserStatusBadge';
import UserRoleBadge from './UserRoleBadge';
import messages from '../../../res/translations/messages';
import {userHasPermission} from '../../utils/auth';

/* eslint-disable react/jsx-no-bind */
const UserItem = ({createdAt, email, enabled, id, name, onImpersonate, organization, roles}) => (
    <tr>
        <td>{email}</td>
        <td>{name}</td>
        <td>{organization.name}</td>
        <td><UserStatusBadge enabled={enabled} /></td>
        <td>
            {roles.map((role) => <UserRoleBadge key={role} className="mr-1" role={role} />)}
        </td>
        {/* <td>{organization && organization.allowEvents && <Badge color="success"><FormattedMessage {...messages.admin.users.enabled} /></Badge>}</td> */}
        {/* <td> */}
        {/* {organization && organization.pinpointAppId && <Badge color="success"><FormattedMessage {...messages.admin.users.enabled} /></Badge>} */}
        {/* {organization && organization.isSendEnabled && <Badge color="success"><FormattedMessage {...messages.admin.users.enabled} /></Badge>} */}
        {/* </td> */}
        <td className="text-nowrap"><FormattedDate value={createdAt} /> <FormattedTime value={createdAt} /></td>
        <td>
            <div className="btn-toolbar">
                <div className="btn-group">
                    <Link className="btn btn-outline-primary btn-sm" to={`/admin/users/${id}/edit`}>
                        <FormattedMessage {...messages.buttons.edit} />
                    </Link>
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => onImpersonate(id)}
                        disabled={userHasPermission(roles, constants.PERMISSIONS.ADMIN)}>
                        <FormattedMessage {...messages.buttons.impersonate} />
                    </button>
                </div>
                {/* <button type="button" className="btn btn-outline-danger btn-sm">
                    <FormattedMessage {...messages.buttons.remove} />
                </button> */}
            </div>
        </td>
    </tr>
);
/* eslint-enable react/jsx-no-bind */

export default UserItem;
